import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { default as commonUtil, default as CommonUtil } from "../../../common/commonUtil";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getPlanList, setTempReserveInfo } from "../../../const/RTCC";
import MessageConst from '../../../const/RTCC/messageConst';
import { useRtoaster } from '../../../hooks/useRtoaster';
import common from "../../../resources/RTCC/js/common/common";
import { Label } from '../../atoms/RTCC/label';
import { PlanCount } from "../../atoms/RTCC/planCount";
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { LabelInputForm } from "../../molecules/RTCC/labelInputForm";
import { ModalOptionForm } from '../../molecules/RTCC/modalOptionForm';
import { PlanList } from "../../molecules/RTCC/planList";
import { PullDownOptionForm } from '../../molecules/RTCC/pullDownOptionForm';
import { FooterContainer } from '../../organisms/RTCC/footerContainer';
import './../../../resources/RTCC/css/reservation/reservation.css';
import { RtccPlanTitleContainer } from "./rtccPlanTitleContainer";
import SideSearchFormContainer from "./sideSearchFormContainer";

const RtccReservationResultContainer = (props) => {
    const {
        state,
        checkIn,
        checkOut,

        course,
        detailCondition,

        area,
        country,
        city,
        group,
        roomHome,
        roomOverseas,
        human,
        keyWord,
        searchParam,
        toUserInputInfo,
        stayInfo,
        dispRoom,
        setDetailCondition,
        setArea,
        setCountry,
        setCity,
        setGroup,
        setRoomHome,
        setRoomOverseas,
        setHuman,
        setKeyWord,
        setSearchParam,
        setSearchResult,
        setKaiinken,
        setPopupData,
        setPopupMessage,
        setToUserInputInfo,
        setStayInfo,
        setBeforeAreaId,
        setBeforeCountryId,

        kaiinken,
        login,
        onClickOpenReservationPopupWindow,
        onClickOpenCheckListWindow,
        onClickOpenCalendarWindow,
        onChangeRoom,
        onChangeHuman,
        createAgeCountList } = props;

    const [NotSearch, setNotSearch] = useState(false);
    const [NotStart, setNotStart] = useState(false);
    const [NotDate, setNotDate] = useState(false);
    const [NotFacility, setNotFacility] = useState(false);
    const [flgList, setFlgList] = useState({});
    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [displaySwitch, setDisplaySwitch] = useState(searchParam.searchParam.overseasHomeFlg);

    const [vacancyInfo, setVacancyInfo] = useState([]);
    const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");

    const history = useHistory();
    const store = useStore();
    moment.locale('ja')

    // プラン一覧
    const [hotelList, setHotelList] = useState([]);
    const [sortType, setSortType] = useState([{ id: "asc", value: "安い順" }, { id: "dsc", value: "高い順" }]);
    const [linkList, setLinkList] = useState([]);
    const [planNum, setPlanNum] = useState(0);

    // rtoasterタグ生成
    let totalAdultNum = 0;
    let totalChildNum = 0;
    let totalChildAgeList = [];
    stayInfo.forEach(value => {
        totalAdultNum += Number(value.adultNum);
        totalChildNum += Number(value.childNum);
        if (value.ageList?.length) {
            totalChildAgeList.push(value.ageList.join(","));
        }
    })
    const customParam = {
        "areaid": searchParam.searchParam.areaId,
        "countryid": searchParam.searchParam.countryId,
        "cityid": searchParam.searchParam.cityIdList.join(","),
        "riyosyodat": searchParam.searchParam.startDate,
        "riyosaisyudat": searchParam.searchParam.endDate,
        "roomsu": searchParam.searchParam.roomNum,
        "adultninzu": totalAdultNum,
        "childninzu": totalChildNum,
        "childage": totalChildAgeList.length ? totalChildAgeList.join(",") : ""
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }]);
        // プラン一覧取得
        let param = store.getState().searchParam.searchParam;
        common.doPost(getPlanList, param, afterGetPlanList);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onChangeKeyWord = (e) => setKeyWord(e.target.value);

    // エリア一覧取得後処理
    const afterGetArea = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            console.log(data.errorMessage);
            return;
        }
        // リスト作成
        let dataList = CommonUtil.getRadioList(data.areaList, "areaId", "areaName", false);
        setArea(dataList);
    }

    // 検索後処理
    const afterGetPlanList = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            handlePlanList(commonUtil.sortFee(data.hotelList, "asc"));
        }
    }

    // 表示順変更
    const handleDisplayOrder = () => {
        let list = hotelList.slice(0, hotelList.length);
        let sort = document.getElementById("sort").value;
        setHotelList(commonUtil.sortFee(list, sort));
    }

    // プラン一覧取得
    const handlePlanList = (list) => {
        let hotelList = [];
        let planNum = 0;
        list.map((hotel, index) => {
            let planList = [];
            hotel.planList.map((plan, index) => {
                let planObj = {
                    planId: plan.planId,
                    planName: plan.planName,
                    roomName: plan.roomName,
                    fee: plan.fee,
                    planDescriptions: plan.planDescriptions,
                    roomDescriptions: plan.roomDescriptions,
                    roomImages: plan.roomImages,
                    notes: plan.notes,
                    notification: plan.notification,
                    cancelDescriptions: plan.cancelDescriptions,
                    feeRank: plan.feeRank,
                    lc_flg: plan.lc_flg
                }
                planList.push(planObj);
                planNum++;
            })
            let hotelObj = {
                hotelId: hotel.hotelId,
                propertyImages: hotel.propertyImages,
                hotelName: hotel.hotelName,
                hotelNameAbbr: hotel.hotelNameAbbr,
                address: hotel.address,
                access: hotel.access,
                propertyDescriptions: hotel.propertyDescriptions,
                propertyAmenities: hotel.propertyAmenities,
                remark: hotel.remark,
                // hotelRank: hotel.hotelRank,
                planList: planList
            }
            hotelList.push(hotelObj);
        })
        setPlanNum(planNum);
        setHotelList(hotelList)
        window.scroll({ top: 0, behavior: 'smooth' })
    }

    // ホテル詳細ポップアップ
    const handleHotelDetail = (hotelId) => {
        let popupData = {};
        hotelList.map((value, index) => {
            if (value.hotelId == hotelId) {
                popupData = {
                    hotelId: value.hotelId,
                    propertyImages: value.propertyImages,
                    hotelName: value.hotelName,
                    hotelNameAbbr: value.hotelNameAbbr,
                    address: value.address,
                    access: value.access,
                    propertyDescriptions: value.propertyDescriptions,
                    propertyAmenities: value.propertyAmenities,
                    remark: value.remark,
                    // hotelRank: value.hotelRank
                }
            }
        })
        setPopupData("ホテル詳細", "hotelDtail", popupData);
    }
    // プラン詳細ポップアップ
    const handlePlanDetail = (hotelId, planId) => {
        let startDate = document.getElementById("checkIn").innerHTML;
        let endDate = document.getElementById("checkOut").innerHTML;
        let popupData = {};
        hotelList.map((hotel, index) => {
            if (hotel.hotelId == hotelId) {
                hotel.planList.map((plan, index) => {
                    if (plan.planId == planId) {
                        popupData = {
                            propertyImages: plan.roomImages,
                            hotelId: hotel.hotelId,
                            hotelName: hotel.hotelName,
                            planId: plan.planId,
                            planName: plan.planName,
                            roomNum: dispRoom,
                            roomName: plan.roomName,
                            fee: "¥" + Number(plan.fee).toLocaleString(),
                            planDescriptions: plan.planDescriptions,
                            roomDescriptions: plan.roomDescriptions,
                            notes: plan.notes,
                            notification: plan.notification,
                            cancelDescriptions: plan.cancelDescriptions,
                            feeRank: plan.feeRank,
                            lc_flg: plan.lc_flg,
                            startDate: startDate,
                            endDate: endDate,
                        }
                    }
                })
            }
        })
        setPopupData("プラン詳細", "planDetail", popupData);
    }
    // 検索条件保存
    const handleSaveSearchCondition = () => {
        // リクエスト作成
        let roomCount = document.getElementById("roomCount").value;

        let areaId = "";
        for (var i in area) {
            if (area[i].checked === true) {
                areaId = areaId + (areaId == "" ? "" : ",");
                areaId = areaId + area[i].value;
            }
        }
        // 国
        let countryId = "";
        for (var i in country) {
            if (country[i].checked === true) {
                countryId = countryId + (countryId == "" ? "" : ",");
                countryId = countryId + country[i].value;
            }
        }
        // 都市
        let cityId = "";
        for (var i in city) {
            if (city[i].checked === true) {
                cityId = cityId + (cityId == "" ? "" : ",");
                cityId = cityId + city[i].value;
            }
        }
        let reqParam = {
            loginId: login.memberCode,
            keyWord: keyWord,
            areaId: areaId,
            countryId: countryId,
            cityId: cityId,
            roomCount: Number(roomCount),
            roomCapacity: 1
        }
        setPopupData("検索条件の保存", "saveFavorite", reqParam);
        setPopupMessage(MessageConst.CONFIRM_SAVE_FAVORITE);
    }
    // 「予約する」ボタン押下
    const handleReserve = (hotelId, planId, roomName) => {
        console.log( "stayInfo" + stayInfo);
        let hotelName = "";
        let planName = "";
        let planFee = "";
        let startDate = document.getElementById("checkIn").innerHTML;
        let endDate = document.getElementById("checkOut").innerHTML;
        let cancelDescriptions = "";
        hotelList.map((hotel, index) => {
            if (hotel.hotelId == hotelId) {
                hotelName = hotel.hotelName;
                hotel.planList.map((plan, index) => {
                    if (plan.planId == planId) {
                        planName = plan.planName;
                        planFee = plan.fee;
                        cancelDescriptions = plan.cancelDescriptions;
                    }
                })
            }
        })
        setToUserInputInfo({
            hotelId: hotelId,
            hotelName: hotelName,
            planId: planId,
            planName: planName,
            planFee: planFee,
            roomNum: dispRoom,
            roomType: roomName,
            startDate: startDate,
            endDate: endDate,
            cancelDescriptions: cancelDescriptions,
            reserveId: ""
        });

        console.log( "stayInfo" + stayInfo);
        let reqStayInfo = [];
        stayInfo.map((value, humanIndex) => {
            let ageList = value.ageList;
            let childAge = "";
            ageList.map((value, index) => {
                childAge = index == 0 ? value : childAge + "," + value;
            })
            reqStayInfo.push({
                roomCount: humanIndex + 1,
                adultNum: Number(value.adultNum),
                childNum: Number(value.childNum),
                childAge: childAge
            })
        })

        // 一時予約
        let param = {
            loginId: login.memberCode,
            planId: planId,
            hotelId: hotelId,
            checkInDate: moment(startDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
            checkOutDate: moment(endDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
            requestVacancyNum: dispRoom,
            stayInfo: reqStayInfo,
        };
        common.doPost(setTempReserveInfo, param, afterSetTempReserveInfo);
    }

    const afterSetTempReserveInfo = (res) => {
        if (res.data) {
            history.push("/reserve/rtcc/userInput");
        }
    }

    // ホテル画像エラー時処理
    const handleErrorHotel = (index) => {
        let newHotelList = [];
        hotelList.forEach((hotel, hotelIndex) => {
            if (hotelIndex != index) {
                newHotelList.push(hotel);
            }
        })
        calcPlanNum(newHotelList);
        setHotelList(newHotelList);
    }

    // プラン画像エラー時処理
    const handleErrorPlan = (hotelId, planId) => {
        let newHotelList = [];
        hotelList.forEach((hotel, hotelIndex) => {
            if (hotel.hotelId == hotelId) {
                let newPlanList = [];
                hotel.planList.forEach((plan) => {
                    if (plan.planId != planId) {
                        newPlanList.push(plan);
                    }
                });
                hotel.planList = newPlanList;
            }
            newHotelList.push(hotel);
        });
        calcPlanNum(newHotelList);
        setHotelList(newHotelList);
    }

    // 該当プラン件数計算
    const calcPlanNum = (list) => {
        let count = 0;
        if (list) {
            list.forEach((hotel) => {
                if (hotel.planList) {
                    hotel.planList.map((plan) => {
                        count++;
                    })
                }
            })
        }
        setPlanNum(count);
    }

    return (
        <div>
            <RtccPlanTitleContainer
                login={login}
                state={state}
                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                handleSaveSearchCondition={handleSaveSearchCondition}
                handlePlanList={handlePlanList}
                createAgeCountList={createAgeCountList}
                displaySwitch={displaySwitch}
            />
            <div className={isMobilePhone ? "reservationResultInnerWrapperSp" : "reservationResultInnerWrapper"}>
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="検索結果"
                    lastLabelClassName="lastLabel"
                />
                <div className="searchResultMobilewrap">
                    <LabelInputForm
                        id="keyWord"
                        placeholder="例）ワイキキホテル"
                        value={keyWord}
                        className={flgList.errInputWord ? "popupButtonKeywordErr" : "popupButtonKeyword "}
                        onChange={onChangeKeyWord}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                    />
                    <div className="resultSearchCondition">
                        <ModalOptionForm
                            wrapClassName="searchConditionWrap"
                            className="saveSearchConditionBtn"
                            onClick={handleSaveSearchCondition}
                            text="この検索条件を保存"
                        />
                        <ModalOptionForm
                            wrapClassName="searchConditionWrap"
                            className="searchConditionBtn"
                            onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}
                            text={"保存した検索条件"}
                        />
                    </div>
                </div>
                <div style={styles.reservationResult}>
                    <div className="searchResultNum">
                        <div className="searchPlanCount">
                            <PlanCount pClass={"spCount"} plan={planNum} spanClass={"courseCountSpan"} />
                        </div>
                        <PullDownOptionForm
                            wrapClassName="searchResultWrap"
                            labelClassName="popupLabel"
                            className="searchResultSort"
                            data={sortType}
                            id={"sort"}
                            onChange={handleDisplayOrder}
                            tabIndex="15"
                        />
                    </div>
                </div>
                <div style={styles.reservationResult}>
                    <div className={isMobilePhone ? "hiddenItem" : "searchFormInnerWrapper"}>
                        <div className="searchFormWrapper">
                            <SideSearchFormContainer
                                state={state}
                                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                                displaySwitch={displaySwitch}
                                setVacancyInfo={setVacancyInfo}
                                setVacancyWeek={setVacancyWeek}
                                setMonthHead={setMonthHead}
                                setMonthLast={setMonthLast}
                                setBeforeAreaId={setBeforeAreaId}
                                setBeforeCountryId={setBeforeCountryId}
                                handlePlanList={handlePlanList}
                                setPopupData={setPopupData}
                                setPopupMessage={setPopupMessage}
                                handleSaveSearchCondition={handleSaveSearchCondition}
                                createAgeCountList={createAgeCountList}
                            />
                        </div>
                    </div>
                    <div className="planListInnerWrapper">
                        <PlanList
                            hotelList={hotelList}
                            hotelListWrapperName={"hotelListWrapper"}
                            planListWrapperName={"planListWrapper"}
                            planWrapperName={"planWrapper"}
                            planListStyle={styles.planList}
                            hotelImgStyle={styles.hotelImg}
                            handleHotelDetail={handleHotelDetail}
                            handlePlanDetail={handlePlanDetail}
                            handleReserve={handleReserve}
                            handleErrorHotel={handleErrorHotel}
                            handleErrorPlan={handleErrorPlan}
                            isWideTablet={isWideTablet}
                        />
                    </div>
                </div>
                <div className="backTopSearchResult">
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer />
            </div>
        </div>

    );
};


const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        group: state.group,
        roomHome: state.roomHome,
        roomOverseas: state.roomOverseas,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        toUserInputInfo: state.toUserInputInfo,
        stayInfo: state.stayInfo,
        dispRoom: state.dispRoom,
        searchParam: state.searchParam,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoomHome: (item) => {
            dispatch({ type: "ROOM_HOME", payload: { roomHome: item } })
        },
        setRoomOverseas: (item) => {
            dispatch({ type: "ROOM_OVERSEAS", payload: { roomOverseas: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setStayInfo: (item) => {
            dispatch({ type: "STAY_INFO", payload: { stayInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccReservationResultContainer);

const styles = {
    reservationResult: {
        display: "flex",
        width: "100%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "gray",
        marginBottom: "20px",
        paddingTop: "8px",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    planList: {
        width: "100%",
        paddingBottom: "30px"
    },
    hotelImg: {
        width: "100%"
    },
    footer: {
        width: "80%",
        padding: "30px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
}